
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-14a6.5 6.5 0 100 13 6.5 6.5 0 000-13z"}}),_c('path',{attrs:{"d":"M8.01 5.78a.83.83 0 00.86-.8v-.04a.84.84 0 00-.82-.86H8a.85.85 0 00-.88.82v.04a.84.84 0 00.84.84H8zm-.68.78v4.94h1.35V6.56H7.33z"}})])
          )
        }
      }
    